export const api = {
    dashboard: (roomId: string): string => `/api/audits/${roomId}/dashboard/`,
    users: (roomId: string): string => `/api/audits/accounts/${roomId}/members/`,
    usersOptions: (): string => '/api/audits/accounts/members/',
    successfulLogins: (roomId: string): string =>
        `/api/audits/accounts/${roomId}/successful-logins/`,
    failedLogins: (roomId: string): string => `/api/audits/accounts/${roomId}/failed-logins/`,
    devices: (roomId: string): string => `/api/audits/devices/${roomId}/`,
    devicesOptions: (): string => '/api/audits/devices/',
    encryptionKeysRemovalRequests: (organisationId: string): string =>
        `/api/organisations/${organisationId}/encryption-key-removal-request/`,
    encryptionKeysRemovalRequest: (organisationId: string, requestId: string): string =>
        `/api/organisations/${organisationId}/encryption-key-removal-request/${requestId}/`,
    actionLogOptions: (): string => '/api/audits/actionhistory/',
    actionLogEntries: (memberId: string, roomId: string): string =>
        `/api/audits/accounts/${roomId}/members/${memberId}/actionhistory/`
};
